import { createContext } from 'react';
import type {
  V2GasMonitorConfigDetailPostResponse,
  V2GasMonitorMapGasCostTrendPostResponse,
  V2GasMonitorMapGasUsageTrendPostResponse,
  V2GasMonitorMapGetEnergyCostPostResponse,
  V2GasMonitorMapGetEnergyUsagePostResponse,
  V2GasMonitorMapGetMonthlyAndAnnualGasUsagePostResponse,
} from '@maxtropy/device-customer-apis-v2';
import type { Dayjs } from 'dayjs';
import { IndexTimeActive } from './components/LeftBox/SwitchDate';

export interface GasMonitorContextProps {
  timeResolution?: IndexTimeActive;
  setActiveKey?: React.Dispatch<React.SetStateAction<IndexTimeActive>>;
  dateValue?: Dayjs;
  setValue?: React.Dispatch<React.SetStateAction<Dayjs | undefined>>;
  configDetail?: V2GasMonitorConfigDetailPostResponse;
  configLoading?: boolean;
  energyCostData?: V2GasMonitorMapGetEnergyCostPostResponse;
  energyCostLoading?: boolean;
  energyUsageData?: V2GasMonitorMapGetEnergyUsagePostResponse;
  energyUsageLoading?: boolean;
  monthAndAnnualData?: V2GasMonitorMapGetMonthlyAndAnnualGasUsagePostResponse;
  monthAndAnnualLoading?: boolean;
  gasUsageTrendData?: V2GasMonitorMapGasUsageTrendPostResponse;
  gasUsageTrendLoading?: boolean;
  gasCostTrendData?: V2GasMonitorMapGasCostTrendPostResponse;
  gasCostTrendLoading?: boolean;
}

export const GasMonitorContext = createContext<GasMonitorContextProps>({});
